import styles from "../card/AnalyticsCard.module.scss";
import AnalyticsCard, { AnalyticsCardType } from "../card/AnalyticsCard";
import AnalyticsSegmentedBar from "../segmented-bar/AnalyticsSegmentedBar";
import AnalyticsTrend, { AnalyticsTrendDirection, AnalyticsTrendTone } from "../trend/AnalyticsTrend";

type Props = {
	label: string;
	/** Already formatted for display, e.g. "48,210", "62.4%", "3m 12s". */
	value: string;
	/**
	 * Rendered as given, e.g. "6.2%", "2pt", "8s". Left out together with `direction`
	 * when there is no earlier period to compare against — a badge is a claim about
	 * the data, so it is drawn only when the change is actually known.
	 */
	trend?: string;
	direction?: AnalyticsTrendDirection;
	/** Colour of the trend badge when the arrow alone misleads. Defaults to the direction. */
	tone?: AnalyticsTrendTone;
	/** 0–100, drawn as ten segments. Left out leaves the bar off. */
	percent?: number;
	/** State of the metric — colours the bar, and tints the card when negative. */
	type?: AnalyticsCardType;
};

/** Metric with its change as a pill and a completion bar underneath. */
const AnalyticsProgressCard = ({ label, value, trend, direction, tone, percent, type }: Readonly<Props>) => (
	<AnalyticsCard type={type}>
		<div className={styles.header}>
			<span className={styles.label}>{label}</span>
			{trend && direction && <AnalyticsTrend value={trend} direction={direction} tone={tone} variant="badge" />}
		</div>
		<span className={styles.value}>{value}</span>
		{percent !== undefined && <AnalyticsSegmentedBar percent={percent} />}
	</AnalyticsCard>
);

export default AnalyticsProgressCard;
